export default "__VITE_ASSET__6b2c22de__"